import { render, staticRenderFns } from "./Space.vue?vue&type=template&id=4f4b3a88&"
import script from "./Space.vue?vue&type=script&lang=js&"
export * from "./Space.vue?vue&type=script&lang=js&"
import style0 from "./Space.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports